/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentBracketGroupStanding } from './TournamentBracketGroupStanding';
import {
    TournamentBracketGroupStandingFromJSON,
    TournamentBracketGroupStandingFromJSONTyped,
    TournamentBracketGroupStandingToJSON,
    TournamentBracketGroupStandingToJSONTyped,
} from './TournamentBracketGroupStanding';

/**
 * A group (pool) in a GROUPS_KNOCKOUT bracket. The group stage is round-robin within each pool; the top `advancementSlots` teams advance to the knockout stage (rendered via `rounds`).
 * @export
 * @interface TournamentBracketGroup
 */
export interface TournamentBracketGroup {
    /**
     * 
     * @type {string}
     * @memberof TournamentBracketGroup
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentBracketGroup
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentBracketGroup
     */
    participantIds?: Array<string>;
    /**
     * 
     * @type {Array<TournamentBracketGroupStanding>}
     * @memberof TournamentBracketGroup
     */
    standings?: Array<TournamentBracketGroupStanding>;
    /**
     * How many teams advance from this group to the knockout stage
     * @type {number}
     * @memberof TournamentBracketGroup
     */
    advancementSlots?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentBracketGroup
     */
    isComplete?: boolean;
}

/**
 * Check if a given object implements the TournamentBracketGroup interface.
 */
export function instanceOfTournamentBracketGroup(value: object): value is TournamentBracketGroup {
    return true;
}

export function TournamentBracketGroupFromJSON(json: any): TournamentBracketGroup {
    return TournamentBracketGroupFromJSONTyped(json, false);
}

export function TournamentBracketGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBracketGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'participantIds': json['participantIds'] == null ? undefined : json['participantIds'],
        'standings': json['standings'] == null ? undefined : ((json['standings'] as Array<any>).map(TournamentBracketGroupStandingFromJSON)),
        'advancementSlots': json['advancementSlots'] == null ? undefined : json['advancementSlots'],
        'isComplete': json['isComplete'] == null ? undefined : json['isComplete'],
    };
}

export function TournamentBracketGroupToJSON(json: any): TournamentBracketGroup {
    return TournamentBracketGroupToJSONTyped(json, false);
}

export function TournamentBracketGroupToJSONTyped(value?: TournamentBracketGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupId': value['groupId'],
        'name': value['name'],
        'participantIds': value['participantIds'],
        'standings': value['standings'] == null ? undefined : ((value['standings'] as Array<any>).map(TournamentBracketGroupStandingToJSON)),
        'advancementSlots': value['advancementSlots'],
        'isComplete': value['isComplete'],
    };
}

